export default __webpack_public_path__ + "static/media/flag-belize.3dfe8af0.svg";